(() => {
  document.addEventListener('submit', event => {
    const submitted = event.target;
    if (!(submitted instanceof HTMLFormElement) || !submitted.querySelector('[name="form_type"][value="localization"]')) return;
    const destination = submitted.querySelector('[name="return_to"]');
    if (destination) destination.value = location.pathname + location.search + location.hash;
  }, {capture:true});
  const form = document.getElementById('VeLanguageMarketSync');
  const context = form?.querySelector('[data-ve-market-context]');
  if (!form || !context) return;
  const key = 'veNativeMarketAlignment';
  if (context.dataset.currentCountry === context.dataset.targetCountry) {
    try { sessionStorage.removeItem(key); } catch {}
    return;
  }
  const signature = [location.pathname, context.dataset.currentCountry, context.dataset.targetCountry].join('|');
  try {
    if (sessionStorage.getItem(key) === signature) return;
    sessionStorage.setItem(key, signature);
  } catch {}
  const returnTo = form.querySelector('[name="return_to"]');
  if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  form.requestSubmit();
})();
